/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon16Solid = forwardRef('ArrowDCornerRightUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14.384 5.366a1.25 1.25 0 0 1-1.768 1.768L10.25 4.768V12A3.25 3.25 0 0 1 7 15.25H1.25a1.25 1.25 0 1 1 0-2.5H7a.75.75 0 0 0 .75-.75V4.768L5.384 7.134a1.25 1.25 0 0 1-1.768-1.768l3.652-3.651a2.45 2.45 0 0 1 3.464 0l3.652 3.651Z" })));
});
